"use scrict";

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');
global.md = new MobileDetect(window.navigator.userAgent);
var mainWidth;

import silencio_anim from './sub/silencio_anim';

$(function(){

  // window.anim = new silencio_anim();

  vh();

  let animX = (window.innerWidth * .5) - (window.innerWidth * .7);
  let animY = (window.innerHeight * .5) - (window.innerWidth * .6);
  $('.anim').css({
    'transform' : 'translate3d('+animX+'px, '+animY+'px, 0)'
  });

  setTimeout(function(){
    $('body').addClass('in');
  },100);

  $(window).on('load pageshow', function(){
    setTimeout(function(){
      $(window).trigger('scroll');
      $('body').addClass('in');
    },500);
  });

  $(window).on('beforeunload', function(){
    setTimeout(function(){
      $('body').removeClass('in');
    },500);
  });

  binds();
});


function binds(){
  $('.burger').click(function(e){
    e.preventDefault();
    $('html').toggleClass('nav-open');
  });

  if($('html').hasClass('home')) {
    $('.nav--top a').unbind('click').click(function(e){
      e.preventDefault();
      var id = $(this).attr('href');
      if(id!='##') {
        $('html').animate({'scrollTop' : $(id).position().top }, 500);
      } else {
        $('html').animate({'scrollTop' : 0 }, 500);
      }
      $('html').removeClass('nav-open');
    });
  }

  $(window).unbind('mousemove').mousemove(function(e){
    let prcx = e.offsetX / window.innerWidth;
    let prcy = e.offsetY / window.innerHeight;
    console.log(prcx, prcy);
  });

  $(window).unbind('mousemove').mousemove(function(e){
    let wx = $('.anim').outerWidth() / 2;
    let wy = $('.anim').outerHeight() / 2;
    let prcx = e.clientX / window.innerWidth;
    let prcy = e.clientY / window.innerHeight;
    let x = (window.innerWidth * prcx) - wx;
    let y = (window.innerHeight * prcy) - wy;
    let rotx = (.5-prcx) * -100;
    let roty = (.5-prcy) * 100;
    $('.anim').css({
      'transform' : 'translate3d('+x+'px, '+y+'px, 0) rotateY('+rotx+'deg) rotateX('+roty+'deg)',
    });
  });
  // $('.home-grid a, .close a').unbind('click').click(function(e){
  //   if(!e.ctrlKey&&!e.altKey&&!e.shiftKey) {
  //     e.preventDefault();
  //     var href = $(this).attr('href');
  //     $('body').removeClass('in');
  //     setTimeout(function(){
  //       window.location.href = href;
  //     }, 300);
  //   }
  // });

  var spinSpeed = 50;
  $('.image--mouseovers').unbind('mouseenter mouseleave').mouseenter(function(){
    $(this).children().each(function(idx){
      var t = $(this);
      setTimeout(function(){
        $(t).siblings().css('opacity',0);
        $(t).css('opacity',1);
      }, spinSpeed*idx);
    });
  }).mouseleave(function(){
    var len = $(this).children().length;
    $(this).children().each(function(idx){
      var t = $(this);
      setTimeout(function(){
        $(t).siblings().css('opacity',0);
        $(t).css('opacity',1);
        if(idx==0) {
          setTimeout(function(){
            $(t).css('opacity',0);
          }, spinSpeed);
        }
      }, spinSpeed*(len-idx));
    });
  });
}

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;
}

$(window).resize(function(){
  resize();
});
